export const MediaPlayerStatusEvent = {
	CONTROL_REPLAY: "MediaPlayer_Control_Replay",
	CONTROL_INIT_START: "MediaPlayer_InitPlay_Start",  //DEPrECATING  (need to remove from main video player)
	CONTROL_INIT_PLAY: "MediaPlayer_InitPlay_[type]",
	CONTROL_INIT_COMPLETE: "MediaPlayer_InitPlay_Complete_[time]",//value (time from start seconds)
	CONTROL_TOGGLE_PAUSE: "MediaPlayer_Control_TogglePause",
	CONTROL_TOGGLE_PLAY: "MediaPlayer_Control_TogglePlay",
	CONTROL_SEEK: "MediaPlayer_ControlSeek_[label]_[time]", //value (1)fwd, (0) prevented fwd or (-1)rwd
	CONTROL_VOLUME_DRAG: "MediaPlayer_Control_VolumeDrag_[time]",
	CONTROL_BACK_BUTTON: "MediaPlayer_Control_BackButton_[time]",
	CONTROL_TOGGLE_UNMUTE: "MediaPlayer_Control_ToggleUnmute_[time]",
	CONTROL_TOGGLE_MUTE: "MediaPlayer_Control_ToggleMute_[time]",
	CONTROL_FULLSCREEN: "MediaPlayer_Control_FullScreen[screenstate]_[time]", //value time in video
	CONTROL_RESIZE: "MediaPlayer_Control_Resize[screenstate]_[time]", //value time in video
	CAST_INIT: "MediaPlayer_Chromecast_InitPlay",
	CAST_STARTED: "MediaPlayer_Chromecast_Started_[time]",//value (time from start seconds)
	CAST_ERROR: "MediaPlayer_Chromecast_Error_[type]",
	CAST_EXIT: "MediaPlayer_Chromecast_Exit",

	STATUS_COMPLETE: "MediaPlayer_VideoComplete",
	STATUS_EXIT: "MediaPlayer_PlayerClosed",

	GESTURE_RESPONSE: 'MediaPlayer_PanelAction_[scene]', //any question response
	INTRO_VIDEO_INIT: 'MediaPlayer_IntroVideoInit',//checking for intro video playback
	INVIDEO_SURVEY_HINT: 'MediaPlayer_InVideoSurveyHint_[scene]',//in video survey hint has been displayed
	INVIDEO_SURVEY_START: 'MediaPlayer_InVideoSurveyStart_[scene]',//in video survey launches
	INVIDEO_SURVEY_END: 'MediaPlayer_InVideoSurveyEnd_[scene]',//in video survey completes

	EXIT_SURVEY_START: 'MediaPlayer_ExitSurveyStart_[time]',//when exit survey launches
	EXIT_SURVEY_END: 'MediaPlayer_ExitSurveyEnd_[time]',//when exit survey ends

	INTRO_SURVEY_START: 'MediaPlayer_IntroSurveyStart_[time]',//when intro survey launches
	INTRO_SURVEY_END: 'MediaPlayer_IntroSurveyEnd_[time]',//when intro survey ends

	RECALL_PROMPT_INIT: 'MediaPlayer_RecallPromptInit_[time]',//Was the recall prompt hit

	FACEBOOK_FEED_START: 'MediaPlayer_FacebookFeedStart_[time]',//when facebook feed launches
	FACEBOOK_FEED_END: 'MediaPlayer_FacebookFeedEnd_[time]',//when facebook feed ends


	FORCE_PLAYER_LOCK: 'MediaPlayer_ForceLock_[time]',//when timeupdate still runs while question is up, we force lock
	LOAD_QUESTION_ERROR: "MediaPlayer_LoadQuestionError_[type]",
	QUESTION_SETUP_ERROR: 'MediaPlayer_QuestionSetupError_[error]',//when question display process fails
	QUESTION_RESPONSE_ERROR: 'MediaPlayer_QuestionResponseError_[error]',//when system tries to submit viewer response and fails
	QUESTION_REQUEST_ERROR: 'MediaPlayer_QuestionRequestError_[error]',//when request for display of new question fials
	ANSWER_POST_ERROR: 'MediaPlayer_AnswerPostError_[error]',//when question response doesnt post to db
	MULTISLIDEQ_EVENT_ERROR: 'MediaPlayer_QuestionEventError_MultiSlideLogic_[error]',//when multislide events fail
	DEFAULTQ_EVENT_ERROR: 'MediaPlayer_QuestionEventError_DefaultLogic_[error]',//when multi-choice / visual scale events fail
	MULTISELECTQ_EVENT_ERROR: 'MediaPlayer_QuestionEventError_MultiSelectLogic_[error]',//when multi select events fail
	QUESTION_RESPONSES_MISSING: 'MediaPlayer_QuestionResponsesMissing_[scene]', //question responses missing after a question set complete
	FINAL_RESPONSE_SUBMISSION_FAIL: 'MediaPlayer_FinalSubmissionFail_[time]', //at end of survey we check to see if all quesitons have been submitted and received by the db, if not this gets triggered
	PLAY_ATTEMPT_FAILED: "MediaPlayer_Error_Attempt_[time]",
	DYNAMIC_QUESTION_CHECK: 'MediaPlayer_DynamicQCheck_[time]',//check for panel update
	DYNAMIC_QUESTION_INSERT: 'MediaPlayer_DynamicInsert_[time]',//insert question into exit
	TUNEOUT_PROMPT: "MediaPlayer_TuneOutPrompt_[scene]",
	TUNEOUT_QUESTION_INIT: "MediaPlayer_TuneOutInit",
	TUNEOUT_QUESTION_END: "MediaPlayer_TuneOutEnd",
	BAD_QUESTION_RESPONDANT: "MediaPlayer_BadRespondant_[error]", // when a user is marked as a bad respondant, error will be their user_id

	//:NOTE:: these two are not player related events, they should be in session status events below
	SESSION_AUTO_SUBSCRIBE: 'SessionPath_AddSub_[type]', //when a user deep links into an experience we auto add the show to their subscriptions
	SESSION_IN_TESTMODE: 'SessionPath_TestMode_[type]', //if the user comes into the player in test mode, this is triggered,  type is the value of the url param test
	//================================================
  
	VIDEOPLAYER_MOUNTED : 'MediaPlayer_Mounted', // it is in view,

	PLAYER_ERROR_ONLOAD: "MediaPlayer_Error_NoLoad",
	PLAYER_ERROR_UNKNOWN: "MediaPlayer_Error_Unknown_[time]",
	PLAYER_ERROR_MEDIA: "MediaPlayer_Error_Media_[time]",
	PLAYER_ERROR_NETWORK: "MediaPlayer_Error_Network_[time]",

	INVALID_USER_PROFILE: 'MediaPlayer_Eject_User',
	USER_CONTENT_PROFILE_ERROR: 'MediaPlayer_Error_UCP'
};

export const ActivityStatusEvent = {
	'BROWSE_PILOTS': 'BrowseLibraryView_BrowsePilots_[state]', //label scroll direction ScrollLeft/ScrollRight
	'BROWSE_CAST': 'DetailLayer_BrowseCast_[state]',//label scroll direction ScrollLeft/ScrollRight
	'BROWSE_DETAILS': 'DetailLayer_ReadDetails_[state]',//label scroll direction ScrollUp/ScrollDown
	'BROWSE_PROFILE': 'ProfileView_Active_[state]',
	'BROWSE_LIBRARY': 'MyLibraryView_Active_[state]',
	'VIEW_TOUR': 'TourView_Active_[state]', //state = open / step # / close, start and close are handled by session events
	'PREPANEL_RESPONSE': 'JoinView_PrePanel_[state]_[duration]' //label  did they fail or succeed
};

export const ActionStatusEvent = {
	'GETINFO_ON_PILOT': 'PilotSelect_[view]_[video_id]', //view (BrowseCoursel , BrowseBackground)
	'WATCH_PILOT_NOW': 'SelectEpisode_MyLibraryView_[video_id]',
	'GETINFO_ON_CAST': 'CastSelect_DetailLayer_[cast_id]',
	'VIEW_TRAILER': 'ViewTrailer_DetailLayer_[video_id]',
	'JOIN_PILOT': 'JoinPilot_[view]_[video_id]',
	'ADD_TO_LIST': 'AddToList_[view]_[video_id]',
	'CONFIRM_JOIN': 'ConfirmJoin_[type]_[video_id]',
	'CANCEL_JOIN': 'CancelJoin_[type]_[video_id]',
	'SOCIAL_SHARE': 'SocialShare_[social_id]_[video_id]',
	'LOGIN_ATTEMPT': 'Signin_Login_[type]',
	'AUTH_LOGOUT': 'Auth_Logout_[view]',
	'GIVE_FEEDBACK': 'Give_Feedback',
	'GET_FEEDBACK': 'Get_Feedback',
	'GDPR_CONSENT': 'GDPR_Consent'
};

export const SessionStatusEvent = {
	'SESSION_HTML_ERROR': '',
	'SESSION_STARTED': 'SessionStarted_[state]_[type]',
	'SESSION_COM_ERROR': '',
	'SESSION_VIEW_LOADED': 'SessionPath_[view]_Active',//TO BE DEPRECATED
	'SESSION_VIEW_CHANGE': 'SessionPath_[view]_[state]_[duration]', //duration in seconds that the view was open

	'CTA_BASIC_LOGIN': 'HomeView_SignIn_[buttonLocation]',
	'CTA_JOIN': 'HomeView_Join_[buttonLocation]',
	'PREPANEL_DISPLAY': 'JoinView_PrePanel_[state]_[questions]', //questions = number of questions listed

	'AUTH_AUTO_LOGIN': 'Auth_AutoLogin_[state]',
	'AUTH_DYNAMIC_LOGIN': 'Auth_DynamicLogin_[state]',
	'AUTH_BASIC_LOGIN': 'Auth_BasicLogin_[state]',
	'AUTH_BASIC_REGISTER': 'Auth_BasicRegister_[state]',
	'AUTH_FORGOT_PASSWORD': 'Auth_BasicForgotPassword_[state]',
	'AUTH_RESET_PASSWORD': 'Auth_BasicResetPassword_[state]',
	'AUTH_SOCIAL_LOGIN': 'Auth_SocialLogin_[type]_[state]',
	'AUTH_SOCIALAUTO_LOGIN': 'Auth_SocialAutoLogin_[type]_[state]',
	'AUTH_SOCIAL_REGISTER': 'Auth_SocialRegister_[type]_[state]',
	'AUTH_REGISTER_STEPTWO': 'Auth_RegisterTwo_[state]',
	'AUTH_FACEBOOK_FEED_PERMISSION': 'AUTH_FbFeedPermission_[state]',
	'AUTH_FACEBOOK_PROMPT_PERMISSION': 'AUTH_FbPromptPermission_[type]_[state]',

	'AUTH_GUEST_LOGIN': 'Auth_GuestLogin_[state]', //GA ONLY OUTPUT

	'AUTH_LOGOUT': 'Auth_Logout_[view]',
	'BRANCH_APP_OPEN': 'Branch_[type]_[state]',
	'NATIVE_AD_INIT': 'BranchInit_[type]_[state]',
	'CURRENT_VIEW': 'View_[type]_[state]',
	'BRANCH_METHOD': 'BranchMethod_[type]_[state]',
	
	'PANEL_SEGMENT_SELECT': 'PanelSegmentSelect_[state]_[type]',

	'FEEDBACK_REDIRECT': 'FeedbackRedirect_[type]',
	'RENDER_FEEDBACK_DISPLAY': 'RenderFeedbackDisplay_[type]'
};

export const UserEvent = {
	'TECH_CHECK_FAIL': 'User_Tech Fail_[type]',
};

export const SVODStatusEvent = {
	SVODSESSION_TIMER: "SVODSession_Timer_[label]", 	// Session Timer
	SVODSESSION_MUTE: "SVODSession_Mute_[label]",	// Global Mute Status
	SVODSESSION_ERROR: "SVODSession_Error_[label]",	// Session Error,
	SVODSESSION_ENVDATA: "SVODSession_envData_[label]",	// Environment Data API Call,
	SVODSESSION_COMMENTSDATA: 'SVODSession_CommentsData_[label]',	// Comment Data API call
	SVODSESSION_VIEW: 'SVODSession_View_[label]',	// SVOD Component Rendering
	SVODSESSION_STARTSURVEY: 'SVODSession_StartSurvey_[label]',	// SVOD Initialize Survey
	SVODSESSION_ENDSURVEY: 'SVODSession_EndSurvey_[label]', 	// SVOD End Survey

	SVODSESSION_ENTERPAGE: 'SVODSession_EnterPage_[label]', // SVOD Enter Page, the page location of svod (home_page, etc)
	SVODSESSION_EXITPAGE: 'SVODSession_ExitPage_[label]', 	// SVOD Exit Page, the page location that is exited (home_page, etc)
	SVODSESSION_INFOMODAL: 'SVODSession_InfoModal_[label]', // home_page-did_you_notice (label example)
	SVODSESSION_WATCHASSET: 'SVODSession_WatchAsset_[label]', //

	SVODPLAYER_TILEVIDEO: "SVODPlayer_TileVideo_[label]", 	// Video playback on tile
	SVODPLAYER_DETAILSVIDEO: "SVODPlayer_DetailsVideo_[label]", 	// Video playback in show details
	SVODPLAYER_FSVIDEO: "SVODPlayer_fsVideo_[label]",	// Video playback in full screen
	SVODPLAYER_BILLBOARDVIDEO: "SVODPlayer_BillboardVideo_[label]", 	// Video playback in billboard
	SVODPLAYER_HIGHLIGHTVIDEO: "SVODPlayer_HighlightVideo_[label]",	// Video playback in highlight row
	SVODPLAYER_ERROR: "SVODPlayer_Error_[label]",	// Video playback in highlight row

	SVODACTION_LOGOUT: 'SVODAction_Logout_[label]', 	// Log-out
	SHOWDETAILS_DISPLAY: "ShowDetails_Display_[label]", 	// Show-details display
	SHOWDETAILS_MOREDETAILS: 'ShowDetails_MoreDetails_[label]',	// More-details display
	SHOWDETAILS_COMMENTS: "ShowDetails_Comments_[label]", 	// Comments section within Show-details

};


// WEBPACK FOOTER //
// ./src/analytics/analytics-events/constants.js